import React, { useEffect, useState, useRef } from "react";
import { Link } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import axios from "axios";
import { backend_url } from "../../App";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "./Hero.css";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";

const Hero = () => {
  const [banners, setBanners] = useState([]);
  const swiperRef = useRef(null);

  useEffect(() => {
    fetchBanners();
  }, []);

  const fetchBanners = async () => {
    try {
      const response = await axios.get(`${backend_url}/api/landingbanner`);
      setBanners(response.data);
    } catch (error) {
      console.error("Error fetching banners:", error);
    }
  };

  return (
    // <div className="relative hero">
    //   {/* Swiper */}
    //   <Swiper
    //     modules={[Navigation, Pagination, Autoplay]}
    //     spaceBetween={50}
    //     slidesPerView={1}
    //     pagination={{ clickable: true }}
    //     autoplay={{ delay: 3000 }}
    //     loop={true}
    //     onSwiper={(swiper) => (swiperRef.current = swiper)}
    //     allowSlideNext={true}
    //     allowSlidePrev={true}
    //     className="hero-swiper"
    //     style={{ marginBottom: '60px', marginTop: '10px' }}
    //   >
    //     {banners.map((banner) => (
    //       <SwiperSlide key={banner._id}>
    //         <Link
    //           to={`collections/${banner.routeTo}`}
    //           onClick={(e) => {
    //             if (swiperRef.current?.animating) {
    //               e.preventDefault();
    //             }
    //           }}
    //         >
    //           <img crossOrigin="anonymous" 
    //             src={`${banner.image}`}
    //             alt={banner.category}
    //             className="hero-image"
    //           />
    //         </Link>
    //       </SwiperSlide>
    //     ))}
    //   </Swiper>

    //   {/* Custom Navigation Buttons (Ensures No Link Click) */}
    //   <button
    //     className="absolute left-5 top-1/2 z-50 transform -translate-y-1/2 bg-[#f8f8f8] text-purple-600 p-3 rounded-full shadow-lg hover:bg-purple-700 hover:text-white transition"
    //     onClick={(e) => {
    //       e.preventDefault();
    //       e.stopPropagation();
    //       swiperRef.current?.slidePrev();
    //     }}
    //   >
    //     <FaChevronLeft size={12} />
    //   </button>

    //   <button
    //     className="absolute right-5 top-1/2 z-50 transform -translate-y-1/2 bg-[#f8f8f8] text-purple-600 p-3 rounded-full shadow-lg hover:bg-purple-700 hover:text-white transition"
    //     onClick={(e) => {
    //       e.preventDefault();
    //       e.stopPropagation();
    //       swiperRef.current?.slideNext();
    //     }}
    //   >
    //     <FaChevronRight size={12} />
    //   </button>
    // </div>
    <div className="relative w-full hero bg-white">
      {/* Swiper */}
      <Swiper
        modules={[Navigation, Pagination, Autoplay]}
        spaceBetween={50}
        slidesPerView={1}
        pagination={{ clickable: true }}
        autoplay={{ delay: 3000 }}
        loop={true}
        onSwiper={(swiper) => (swiperRef.current = swiper)}
        allowSlideNext={true}
        allowSlidePrev={true}
        className="hero-swiper"
        style={{ marginBottom: "60px", marginTop: "10px" }}
      >
        {banners.map((banner) => (
          <SwiperSlide key={banner._id}>
            <Link
              to={`collections/${banner.routeTo}`}
              onClick={(e) => {
                if (swiperRef.current?.animating) {
                  e.preventDefault();
                }
              }}
            >
              {/* <img crossOrigin="anonymous" 
            src={`${banner.image}`}
            alt={banner.category}
            className="w-full h-[200px] sm:h-[300px] md:h-[450px] lg:h-[600px] object-cover object-center rounded-lg"
          /> */}
              <img crossOrigin="anonymous" 
                src={`${banner.image}`}
                alt={banner.category}
                className="w-full h-auto object-contain object-center rounded-lg bg-white"
              />
            </Link>
          </SwiperSlide>
        ))}
      </Swiper>

      {/* Responsive Navigation Buttons */}
      <button
        className="absolute left-2 sm:left-4 top-1/2 z-30 transform -translate-y-1/2 
               bg-white text-purple-600 p-2 sm:p-3 rounded-full shadow-md 
               hover:bg-purple-700 hover:text-white transition duration-300"
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          swiperRef.current?.slidePrev();
        }}
      >
        <FaChevronLeft size={16} />
      </button>

      <button
        className="absolute right-2 sm:right-4 top-1/2 z-30 transform -translate-y-1/2 
               bg-white text-purple-600 p-2 sm:p-3 rounded-full shadow-md 
               hover:bg-purple-700 hover:text-white transition duration-300"
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          swiperRef.current?.slideNext();
        }}
      >
        <FaChevronRight size={16} />
      </button>
    </div>
  );
};

export default Hero;
